import React, { Component, Fragment } from 'react';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import NarrativeFilterBuilder from '../../arcgisFilter/NarrativeFilterBuilder';
import theme from '../../../muiTheme';

const styles = {
  errorDialogContent: {
    width: "800px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
}

class NarrativeQueryDialog extends Component {

  constructor (props)
  {
    super(props);
    this.state =
    {
      filter: '',
      filterState: null
    };
  }

  handleFilterChanged = (filter, filterState) =>
  {
    this.setState({ filter, filterState });
  };

  render() {

    return (
      <Fragment>
      <Dialog
       modal={true}
       open={this.props.open}
       contentStyle={styles.errorDialogContent}
       titleStyle={styles.errorDialogTitle}>
       <NarrativeFilterBuilder
         filterState={this.props.filterForEdit}
         fields={
           [{
               "alias": "Final Report Narrative",
               "editable": true,
               "length": 3999,
               "name": "FinalFireReportNarrative",
               "nullable": true,
               "type": "esriFieldTypeString"
            }]}
         disableUnique={true}
         onChange={this.handleFilterChanged}/>
       <DialogActions>
        <Button onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.props.onSaveNarrativeFilter(this.state.filter, this.state.filterState)
          }} color="primary">
          Save
        </Button>
        <Button onClick={this.props.onClose} color="primary">
          Close
        </Button>
      </DialogActions>
     </Dialog>
      </Fragment>
    )
  }
}

export default NarrativeQueryDialog;
